import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=1a858434&scoped=true&"
import script from "./LangSelect.vue?vue&type=script&lang=ts&"
export * from "./LangSelect.vue?vue&type=script&lang=ts&"
import style0 from "./LangSelect.vue?vue&type=style&index=0&id=1a858434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a858434",
  null
  
)

export default component.exports